import styled from "styled-components";
import { colors } from "../../../../../consts";
import { Paragraph2, WrapperContainer } from "../../../../../components";

export const LineChartTooltipContainer = styled(WrapperContainer)`
  width: 195px;
  background: ${colors.RAISIN_100};
  border-radius: 2px;
`;

export const TooltipHeader = styled(WrapperContainer)`
  span {
    color: ${colors.WHITE};
    font-weight: 800;
    font-size: 14px;
    line-height: 22px;
  }
`;

export const MetricsInfo = styled(WrapperContainer)`
  border-top: 1px solid;
  border-bottom: 1px solid;

  border-color: ${colors.RAISIN_80};

  ${Paragraph2} {
    color: ${colors.RAISIN_10};
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
  }
`;

export const Circle = styled(WrapperContainer)`
  width: 8px;
  height: 8px;
  min-width: 8px;
  min-height: 8px;

  border-radius: 100px;
`;

export const Info = styled(Paragraph2)`
  color: ${colors.WHITE}!important;
  font-weight: 700 !important;
  font-size: 12px !important;
  line-height: 18px !important;
`;
